





























































import { Vue, Component } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import policyService from "@/services/policy.service"
import manageService from "@/services/manage.service"
import { mapGetters } from "vuex"
import { validURL } from "@/utils"
@Component({
    components: {
        PageHeader
    },
    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters("common", [
            "product_type",
            "product_sub_type",
            "corporation",
            "top_dept",
            "software_list",
            "privacy_policy_text_type",
            "area",
            "privacy_policy_status",
            "preparation_status",
            "privacy_policy_sync_way",
            "productSubTypeMap"
        ])
    }
})
export default class ContrastEdit extends Vue {
    readonly currentUser: any
    readonly software_list: any
    readonly privacy_policy_text_type: any
    readonly product_sub_type: any
    readonly area: any
    readonly privacy_policy_status: any
    readonly preparation_status: any
    readonly privacy_policy_sync_way: any
    readonly productSubTypeMap: any
    loading = false
    contrastForm: any = {
        area: undefined,
        product_id: undefined,
        software_id: undefined,
        text_type: undefined,
        policy_external_link: ""
    }
    contrast_id: any = undefined
    product_list: any = []

    labelCol = { span: 4 }
    wrapperCol = { span: 14 }

    get rules() {
        return {
            text_type: [{ required: true, message: "请选择", trigger: "blur" }],
            area: [{ required: true, message: "请选择", trigger: "blur" }],
            policy_external_link: [
                { required: true, message: "请填写", trigger: "blur" },
                { validator: this.validatorUrl }
            ]
        }
    }

    get currentProductList() {
        return this.product_list
            .filter((item: any) => {
                return item.software_id === this.contrastForm.software_id
            })
            .map((item: any) => {
                return {
                    value: item.product_id,
                    label: `${item.product_name}（${
                        this.productSubTypeMap[item.product_sub_type]
                    }）`
                }
            })
    }

    validatorUrl(rule: any, value: any, callback: any) {
        if (value && !validURL(value)) {
            callback("请输入正确的链接！")
        } else {
            callback()
        }
    }

    created() {
        this.contrast_id = Number(this.$route.query.id)
        console.log("this.contrast_id", Boolean(this.contrast_id))

        this.getUserProduct()
        if (this.contrast_id) {
            this.getDetail()
        }
    }

    async changeSoftware() {
        this.contrastForm.product_id = undefined
    }

    async getUserProduct() {
        try {
            const res = await manageService.getUserProduct({
                uid: this.currentUser.uid
            })
            const { list = [] } = res || {}
            this.product_list = list || []
        } catch (error) {
            this.$message.error(`${error}, 获取产品列表失败！`)
        }
    }

    async getDetail() {
        try {
            this.loading = true
            const res = await policyService.getComparePolicy({
                id: this.contrast_id
            })
            this.contrastForm = res || {}
        } catch (error) {
            this.$message.error(`${error}`)
        } finally {
            this.loading = false
        }
    }

    async submit() {
        try {
            await (this.$refs.ruleForm as any).validate()
            const serviceName = this.contrast_id ? "updateComparePolicy" : "createComparePolicy"
            await policyService[serviceName]({
                ...this.contrastForm,
                id: this.contrast_id === 0 ? undefined : this.contrast_id
            })
            this.$message.success("创建成功")
            this.$router.push({
                path: "/channel/contrast-list"
            })
        } catch (error) {
            if (error) {
                this.$message.error(`${error}，创建失败！`)
            }
        }
    }
}
